import { _addEventListener } from "../eventHelper";
import { disableAttribute, toggleStateElement } from "../AccesibilityHelper";

export const automateAriaExpandedElements = () => {
    let ariaExpandedElements = document.querySelectorAll("[aria-expanded]");
    ariaExpandedElements.forEach((ariaExpandedElement) => {
        _addEventListener(ariaExpandedElement, "click", handleAriaExpandedClick);
    });
};

export const handleAriaExpandedClick = (event) => {
    let clickedElement = event.currentTarget;
    const parent = clickedElement.closest("[data-one-expanded-child]");

    if (parent) {
        collapseChildren(parent);
    }

    toggleStateElement(clickedElement, "aria-expanded");
};

const collapseChildren = (parent) => {
    parent.querySelectorAll('[aria-expanded="true"]').forEach((element) => disableAttribute(element, false));
};
